import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
let PagePreviewWithFormMixin = class PagePreviewWithFormMixin extends Vue {
    featuredPhotoUrlFor(images) {
        const featureImage = images[0];
        if (!featureImage) {
            return null;
        }
        if (featureImage.file) {
            return featureImage.file.dataURL;
        }
        return featureImage.url;
    }
};
__decorate([
    Prop({ type: String, required: false, default: 'Page Name' })
], PagePreviewWithFormMixin.prototype, "pageName", void 0);
__decorate([
    Prop({ type: String, required: false })
], PagePreviewWithFormMixin.prototype, "pagePhotoUrl", void 0);
PagePreviewWithFormMixin = __decorate([
    Component
], PagePreviewWithFormMixin);
export default PagePreviewWithFormMixin;
